import { render, staticRenderFns } from "./AppQuestion2.vue?vue&type=template&id=4f212eb1&"
import script from "./AppQuestion2.vue?vue&type=script&lang=js&"
export * from "./AppQuestion2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports